exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html{overflow:hidden!important;scrollbar-width:none;-ms-overflow-style:none}.cti-mo-icon{-webkit-filter:drop-shadow(10px 10px 10px rgba(0,0,0,.2));filter:drop-shadow(10px 10px 10px rgba(0,0,0,.2))}#login_wrapper{margin-top:8rem}", ""]);
